import {Base,Axios} from "@/api/Base"

export class PaymentPersistencyExport extends Base {
    path = "payment/downPersistencyExcel";
    download(param = {}) {
      return Axios.post(this.path,param,{  responseType: "blob" })
  }
}